import React from 'react';
import { TabbedNavigation, TabbedNavigationItem } from '@amzn/storm-ui';
import AACChromeAPI from '@amzn/aac-chrome-api';
import { getClickEventHandler } from 'src/commons/utils';
import { SectionNavItem } from 'src/app/slice';
import { SectionNavContainer } from './style';
import { usePageHeaderBundle } from 'src/providers/PantherLocalizationProvider';
import { LaunchFlag } from 'src/commons/components/LaunchFlag/LaunchFlag';

export interface SectionNavProps {
  selectedItemId?: string;
  items: SectionNavItem[];
  isMobile?: boolean;
}

const SectionNav: React.VFC<SectionNavProps> = ({
  selectedItemId,
  items,
  isMobile,
}) => {
  const headerTranslation = usePageHeaderBundle();
  return (
    <SectionNavContainer
      id="sectionNav"
      role="navigation"
      isMobile={isMobile}
      aria-label={headerTranslation.getMessage('page-header-section-nav-label')}
    >
      <TabbedNavigation>
        {items &&
          items.map((item: SectionNavItem) => {
            const { id, label, href, flag } = item;

            const eventHandler = getClickEventHandler(
              item,
              AACChromeAPI.getSubsectionsEventTarget(),
            );

            return (
              <TabbedNavigationItem
                key={id}
                active={selectedItemId === id}
                label={label}
                onClick={eventHandler}
                href={href}
                renderEnd={() => <LaunchFlag flag={flag} />}
                data-ccx-e2e-id={`aac-subsection-item-${id}`}
                data-eventid={id}
              />
            );
          })}
      </TabbedNavigation>
    </SectionNavContainer>
  );
};

export default SectionNav;
